import React, { useMemo } from 'react';
import ImageGalleryGrid from '@justpark/ui/src/components/ImageGalleryGrid';
import Amenities from './Amenities';
import ListingInformation from '../ListingInformation';
import type { Listing } from '../../generated/graphql';

import styles from '../../../static/scss/components/listingDetails/information.module.scss';

type Props = {
  location: Listing,
  t: (string, string) => string
};

const Information = ({ location, t }: Props) => {
  const images = useMemo(
    () =>
      location.photos.map(({ id, normal }) => ({
        id,
        src: normal.url,
        width: normal.width,
        height: normal.height
      })),
    [location.photos]
  );
  return (
    <>
      <div className={styles.informationWrapper}>
        <ListingInformation
          location={location}
          className={styles.listingInformation}
          customScroll={false}
          bottomSlot={
            !!images?.length && (
              <div className={styles.images}>
                <ImageGalleryGrid images={images} t={t} />
              </div>
            )
          }
        />
      </div>

      {!!location.amenities?.length && (
        <div className={styles.amenities}>
          <Amenities amenities={location.amenities} />
        </div>
      )}
    </>
  );
};

export default Information;
